// Strixly — Zentrale UI-Texte
// Alle Texte hier ändern — nie in den Pages direkt.
// Strixly spricht als Person (Ich-Form), KI wird transparent genannt.

// ── Dashboard ──
export const DASHBOARD = {
  greetingMorning:   'Guten Morgen',
  greetingDay:       'Guten Tag',
  greetingEvening:   'Guten Abend',
  greetingNight:     'Gute Nacht',
  subMorning:        'Was können wir heute retten?',
  subDay:            'Hunger? Lass uns was finden.',
  subEvening:        'Lass mich das Denken übernehmen.',
  subNight:          'Nacht-Snack? Ich helfe dir.',
  tippLabel:         '🦉 Strixlys Tipp',
  schaetzwert:       'Mein letzter Schätzwert',
  demoHint:          'Das sind Beispieldaten — scann deinen Kühlschrank und ich zeige dir was wirklich weg muss.',
  zuleztGerettet:    'Was du zuletzt gerettet hast',
  neuesteEntdecken:  'Was andere gerade entdecken',
  statLabel:         'Rezepte vor dem Vergessen bewahrt',
  statGeplant:       'Diese Woche geplant',
  statAblaufend:     'Ablaufende Zutaten',
  emptyIcon:         '🦉',
  emptyTitle:        'Noch nichts hier — aber das ändern wir.',
  emptyText:         'Zeig mir ein Foto von deinem Kühlschrank — ich kümmere mich um den Rest.',
  emptyBtn:          'Kühlschrank scannen',
  ctaPrimaryLabel:   'Kühlschrank scannen',
  ctaPrimarySub:     'Mein KI-Auge erkennt was weg muss',
  ctaSecondaryLabel: 'Rezept importieren',
  ctaSecondarySub:   'Handschrift · URL · Foto',
};

// ── Kühlschrank-Scan ──
export const FRIDGE = {
  pageTitle:         'Was koche ich heute?',
  pageSub:           'Zeig mir was du hast — ich finde heraus was daraus werden kann.',
  scanStep1:         'Ich werfe kurz mein KI-Auge darauf…',
  scanStep2:         'Meine KI erkennt folgende Zutaten…',
  scanStep3:         'Ich suche was dazu passt…',
  scanStep4:         'Ich lasse die KI ein Rezept für dich berechnen…',
  streamLoading:     'Lass meine KI kurz nachdenken…',
  scanWarning:       'Ich brauche noch einen Moment — meine KI arbeitet daran.',
  aiBadge:           'KI-generiert',
  saveBtn:           'Rezept retten',
  savingBtn:         'Wird gerettet…',
  feedbackLabel:     'War dieser Vorschlag hilfreich?',
  dislikeBtn:        'Nicht das Richtige',
  resetBtn:          '↩ Nochmal scannen',
  emptyIngredients:  'Hmm — da konnte mein KI-Auge nichts erkennen. Helles Licht hilft, und alle Lebensmittel sollten sichtbar sein.',
  noMatchText:       'Keine passenden Rezepte in der Datenbank — aber das KI-Rezept oben ist frisch für dich berechnet!',
};

// ── Rezeptliste (Desktop + Mobile) ──
export const RECIPE_LIST = {
  title:             'Was kochst du heute?',
  subtitle:          (total) => `${total} Ideen — ich helfe dir die richtige zu finden.`,
  subtitleWithTags:  (total, tags) => `${total} Rezepte mit: ${tags}`,
  loading:           'Ich lade Rezepte…',
  errorTitle:        'Fehler beim Laden',
  errorText:         'Rezepte konnten nicht geladen werden. Bitte Seite neu laden.',
  emptyTitle:        'Nichts gefunden',
  emptyText:         'Probier einen anderen Filter — ich schaue nochmal.',
  loadMore:          (count) => `Mehr anzeigen (${count} weitere)`,
  loadMoreLoading:   'Lade…',
};

// ── Meine Rezepte ──
export const MY_RECIPES = {
  title:             'Meine Rezepte',
  subtitle:          (count) => `${count} Rezepte vor dem Vergessen bewahrt.`,
  loading:           'Ich lade deine Sammlung…',
  emptyTitle:        'Deine Sammlung wartet.',
  emptyText:         'Zeig mir ein altes Rezept oder deinen Kühlschrank — ich fange an zu sammeln.',
  emptyBtn:          'Jetzt scannen',
  filterEmpty:       'Nichts gefunden — anderer Filter?',
};

// ── Onboarding ──
export const ONBOARDING = {
  title:             'Willkommen bei Strixly! 🦉',
  text:              'Hallo! Ich bin Strixly — entwickelt von Markus, einem Koch mit über 15 Jahren Erfahrung in der Küche. Die Idee dahinter: ein smarter Helfer, der dir den Alltag in der Küche wirklich erleichtert.',
  textDisclaimer:    'Ich bin eine KI, keine Ernährungsberaterin. Bitte prüfe Zutaten, Allergene und Haltbarkeit immer selbst.',
  btn:               'Los geht\'s! 🍳',
};

// ── Footer ──
export const FOOTER = {
  disclaimer: 'Strixly nutzt Künstliche Intelligenz. Bitte prüfe generierte Rezepte, Haltbarkeiten und Allergene stets selbst.',
};

// ── Feedback ──
export const FEEDBACK = {
  pageTitle:        'Feedback & Beta',
  pageSub:          'Hilf uns Strixly besser zu machen.',
  tabBug:           'Bug melden',
  tabIdea:          'Idee schicken',
  tabBeta:          'Beta-Zugang',
  labelName:        'Dein Name',
  labelEmail:       'Deine E-Mail',
  labelMessage:     'Nachricht',
  labelNameBeta:    'Vor- und Nachname',
  labelEmailBeta:   'E-Mail-Adresse',
  placeholderName:  'Optional',
  placeholderEmail: 'Optional',
  placeholderBug:   'Was ist passiert? Wo genau? Was hast du erwartet?',
  placeholderIdea:  'Welche Funktion würde dir den Alltag erleichtern?',
  placeholderBeta:  'Kurz: Warum möchtest du beim Beta dabei sein?',
  btnSend:          'Absenden',
  btnSending:       'Wird gesendet…',
  successBug:       '✓ Danke! Wir schauen uns das an.',
  successIdea:      '✓ Danke für deine Idee!',
  successBeta:      '✓ Du bist auf der Liste! Wir melden uns.',
  errorGeneric:     'Etwas ist schiefgelaufen. Bitte nochmal versuchen.',
  betaIntro:        'Strixly ist in der geschlossenen Beta. Trag dich hier ein — wir melden uns sobald dein Platz frei ist.',
};

// ── Rezept-Detail ──
export const RECIPE_DETAIL = {
  loading:            'Lade Rezept...',
  notFound:           'Rezept nicht gefunden',
  btnShare:           '🔗 Teilen',
  btnEdit:            'Bearbeiten',
  btnDeleteConfirm:   'Löschen?',
  btnDeleteYes:       'Ja',
  btnDeleteNo:        'Nein',
  btnDelete:          'Löschen',
  labelPortions:      'Portionen',
  labelPrepTime:      'Vorbereitung',
  labelCookTime:      'Kochzeit',
  labelIngredients:   'Zutaten',
  labelForServings:   (n) => `für ${n} Portionen`,
  labelSteps:         'Zubereitung',
  btnAddAll:          'Alle zur Einkaufsliste',
  btnRemoveAll:       'Alle entfernen',
  noAllergens:        'Keine bekannten Allergene',
  allergenKiHint:     '— bitte bei Allergien immer selbst prüfen',
  shareModalTitle:    'Rezept teilen',
  shareWarningText:   'Stelle sicher, dass du berechtigt bist, diesen Inhalt öffentlich zu teilen. Rezepte aus Kochbüchern, Zeitschriften oder anderen urheberrechtlich geschützten Quellen dürfen nicht ohne Erlaubnis des Rechteinhabers geteilt werden.',
  shareCheckboxLabel: 'Ich bestätige, dass ich die Rechte an diesem Inhalt besitze oder es sich um ein eigenes Rezept handelt.',
  btnCreateLink:      'Link erstellen',
  shareLinkHint:      'Dein Rezept ist jetzt über diesen Link erreichbar:',
  btnNativeShare:     'Teilen …',
  btnRevokeLink:      'Link deaktivieren',
  revokeConfirmText:  'Share-Link wirklich deaktivieren? Bestehende Links werden ungültig.',
  btnRevokeConfirm:   'Ja, deaktivieren',
  btnRevokeCancel:    'Abbrechen',
  errCreateLink:      'Fehler beim Erstellen des Links.',
  errRevokeLink:      'Fehler beim Deaktivieren des Links.',
  errDeletePrefix:    'Löschen fehlgeschlagen: ',
};

export const PUSH = {
  sectionTitle:     'Benachrichtigungen',
  sectionDesc:      'Erhalte eine Erinnerung wenn Zutaten in deinem Kühlschrank bald ablaufen.',
  btnEnable:        'Benachrichtigungen aktivieren',
  btnDisable:       'Benachrichtigungen deaktivieren',
  stateActive:      'Aktiv — du erhältst Erinnerungen für ablaufende Zutaten.',
  stateInactive:    'Inaktiv',
  iosHint:          'Auf iPhone: Strixly zum Homescreen hinzufügen um Benachrichtigungen zu erhalten (ab iOS 16.4).',
  errNotSupported:  'Dein Browser unterstützt keine Web-Benachrichtigungen.',
  errDenied:        'Benachrichtigungen sind in deinen Browser-Einstellungen blockiert.',
  errGeneric:       'Benachrichtigungen konnten nicht aktiviert werden.',
  successEnabled:   'Benachrichtigungen aktiviert.',
  successDisabled:  'Benachrichtigungen deaktiviert.',
  timeLabel:        'Erinnerungs-Uhrzeit',
  timeHint:         'Wann soll Strixly dich erinnern wenn Zutaten bald ablaufen?',
  timeSaved:        'Uhrzeit gespeichert.',
  timeBtnSave:      'Speichern',
  hintText:         'Soll Strixly dich erinnern wenn diese Zutaten ablaufen?',
};
